import { ChevronDownIcon, PlusIcon, PuzzleIcon } from "lucide-react";
import { useCallback, useState } from "react";

import { RESPONSIVE_TEXT_BUTTON_CLASS } from "~/lib/touchTarget";
import { useHandleNewThread } from "../../hooks/useHandleNewThread";
import { cn } from "../../lib/utils";
import { Popover, PopoverPopup, PopoverTrigger } from "../ui/popover";

const CREATE_PLUGIN_PROMPT = [
  "$plugin-creator",
  "",
  "Create a new Forge plugin. Start by asking me for the plugin name, purpose, destination, and whether it needs skills, MCP servers, apps, assets, scripts, or marketplace metadata.",
].join("\n");

export function PluginCreateAction() {
  const [open, setOpen] = useState(false);
  const { defaultProjectRef, handleNewThread } = useHandleNewThread();
  const createPlugin = useCallback(() => {
    if (!defaultProjectRef) {
      return;
    }
    setOpen(false);
    void handleNewThread(defaultProjectRef, {
      anchorCmmdId: null,
      anchorKind: "scratch",
      envMode: "local",
      initialPrompt: CREATE_PLUGIN_PROMPT,
    });
  }, [defaultProjectRef, handleNewThread]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        aria-label="Plugin actions"
        // Was `hidden ... sm:flex`, which put the only way to create a plugin
        // out of reach below 640px. Hiding a control is not a mobile density
        // decision; gating its density on the breakpoint is.
        className={cn(
          RESPONSIVE_TEXT_BUTTON_CLASS,
          "inline-flex items-center gap-1 rounded-lg border border-border bg-background px-3 text-foreground outline-none transition-colors hover:bg-accent focus-visible:ring-2 focus-visible:ring-ring md:h-8 md:px-2",
        )}
      >
        <PlusIcon className="size-4" />
        <ChevronDownIcon className="size-3.5 text-muted-foreground" />
      </PopoverTrigger>
      <PopoverPopup align="end" side="bottom" className="w-56 p-1">
        <button
          type="button"
          disabled={!defaultProjectRef}
          onClick={createPlugin}
          className="flex w-full items-center gap-3 rounded-md px-3 py-2 text-left text-sm text-foreground outline-none transition-colors hover:bg-muted focus-visible:bg-muted disabled:pointer-events-none disabled:opacity-50"
        >
          <PuzzleIcon className="size-4 text-muted-foreground" />
          <span className="min-w-0 flex-1">Create plugin</span>
        </button>
      </PopoverPopup>
    </Popover>
  );
}
